module.exports = __webpack_public_path__ + "static/media/google.6b87e7ab.svg";